import { render, staticRenderFns } from "./QAdInsertionMarketDataTable.vue?vue&type=template&id=085392e9&scoped=true&"
import script from "./QAdInsertionMarketDataTable.vue?vue&type=script&lang=js&"
export * from "./QAdInsertionMarketDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QAdInsertionMarketDataTable.vue?vue&type=style&index=0&id=085392e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085392e9",
  null
  
)

export default component.exports